// @flow
import React, { Component, Fragment, type Node } from 'react';
import onClickOutside from 'react-onclickoutside';
import { Link } from 'react-router-dom';
import { MdSettings } from 'react-icons/md';
import cx from 'classnames';

import './SubmitBox.scss';

type Props = {
  isEditing: boolean,
  selectCategory: any,
  inputTags: any,
  inputBadges: any,
  configureThumbnail: Node,
  configureSeries: Node,
  visible: boolean,
  isEdit: boolean,
  onClose(): void,
  onTempSave(): Promise<*>,
  onSubmit(): void,
  onEditCategoryClick(): void,
  onToggleAdditionalConfig(): void,
  additional: Node | false,
  series: Node | false,
  postLink: ?string,
  visibilitySelect: Node,
  rule: string,
  type: string,
};

type State = {
  animating: boolean,
};

class SubmitBox extends Component<Props, State> {
  static defaultProps = {
    isEditing: false,
  };
  animateTimeout: any;
  state = {
    animating: false,
  };

  handleClickOutside = () => {
    const { onClose, visible } = this.props;
    if (!visible) return;
    onClose();
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.visible !== this.props.visible) {
      this.animate();
    }
  }

  componentWillUnmount() {
    clearTimeout(this.animateTimeout);
  }

  animate = () => {
    clearTimeout(this.animateTimeout);
    this.setState({
      animating: true,
    });
    this.animateTimeout = setTimeout(() => {
      this.setState({
        animating: false,
      });
    }, 150);
  };

  render() {
    const {
      isEdit,
      inputTags,
      inputBadges,
      visible,
      onSubmit,
      configureThumbnail,
      onToggleAdditionalConfig,
      additional,
      postLink,
      onTempSave,
      visibilitySelect,
      configureSeries,
      series,
      onEditCategoryClick,
      selectCategory,
      rule,
      type,
    } = this.props;
    const { animating } = this.state;

    let typeName = '포스트';
    switch (type) {
      case 'post':
        typeName = '포스트';
        break;
      case 'product':
        typeName = '상품';
        break;
      case 'brand':
        typeName = '브랜드';
        break;
      case 'banner':
        typeName = '배너';
        break;
      case 'event':
        typeName = '이벤트';
        break;
      case 'letter':
        typeName = '뉴스레터';
        break;
      case 'quote':
        typeName = '견적요청';
        break;
      case 'partner':
        typeName = '파트너';
        break;
      default:
        typeName = '포스트';
    }

    if (!visible && !animating) return null;
    if (series) {
      return <div className={cx('SubmitBox', visible ? 'appear' : 'disappear')}>{series}</div>;
    }

    return (
      <div className={cx('SubmitBox', visible ? 'appear' : 'disappear')}>
        <div className="wrapper">
          <div className="tie">
            <div className="text">
              {isEdit ? `${typeName} 수정하기` : `새 ${typeName} 등록하기`}
            </div>
            {isEdit && postLink && (
              <Link className="view" to={postLink}>
                {`${typeName} 보기`}
              </Link>
            )}
          </div>
          {additional || (
            <Fragment>
              <div className="sections">
                {rule === 'admin' && (
                  <section>
                    <div className="section-title category" onClick={onEditCategoryClick}>
                      카테고리 선택
                      <div className="edit util flex-center">
                        <MdSettings />
                        <div>수정</div>
                      </div>
                    </div>
                    {selectCategory}
                  </section>
                )}
                <section>
                  <div className="section-title">태그 설정</div>
                  {inputTags}
                </section>
                <section>
                  <div className="section-title">뱃지 설정</div>
                  {inputBadges}
                </section>
                <section>
                  <div className="section-title">썸네일 지정</div>
                  {configureThumbnail}
                </section>
                <section>
                  <div className="section-title">시리즈 설정</div>
                  {configureSeries}
                </section>
              </div>
              <div className="footer">
                <div className="buttons">
                  <button className="gray" onClick={onTempSave}>
                    임시저장
                  </button>
                  <button className={cx('purple', { blue: isEdit })} onClick={onSubmit}>
                    {isEdit ? '업데이트' : '작성하기'}
                  </button>
                </div>
                <div className="between">
                  <div className="visibility-select">{visibilitySelect}</div>
                  <div className="open-options">
                    <a onClick={onToggleAdditionalConfig}>추가설정</a>
                  </div>
                </div>
              </div>
            </Fragment>
          )}
        </div>
      </div>
    );
  }
}

export default onClickOutside(SubmitBox);



// WEBPACK FOOTER //
// ./src/components/write/SubmitBox/SubmitBox.js